/**
 * ThemeProgress Component
 * Visar progress för ett tema och nästa obesvarade fråga
 */

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import lifeThemeAPI from '../../services/lifeThemeAPI';

const ThemeProgress = () => {
  const { themeId } = useParams();
  const navigate = useNavigate();
  
  const [progress, setProgress] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadProgress();
  }, [themeId]);

  const loadProgress = async () => {
    try {
      setLoading(true);
      const data = await lifeThemeAPI.getThemeProgress(themeId);
      setProgress(data);
      
      // Om det finns en nästa fråga, navigera direkt dit
      if (data.next_question) {
        navigate(`/client/life-themes/${themeId}/question/${data.next_question.id}`);
      }
    } catch (err) {
      console.error('Error loading progress:', err);
      setError('Kunde inte ladda progress. Försök igen senare.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="flex justify-center items-center min-h-[400px]">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-primary"></div>
        </div>
      </div>
    );
  }

  if (error || !progress) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <p className="text-red-800 mb-4">{error || 'Progress kunde inte laddas'}</p>
          <button
            onClick={() => navigate('/client/life-themes')}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Tillbaka till frågor
          </button>
        </div>
      </div>
    );
  }

  // Om alla frågor är besvarade, gå till sammanfattning
  if (progress.unanswered_questions === 0) {
    navigate(`/client/life-themes/${themeId}/summary`);
    return null;
  }

  // Om det inte finns någon nästa fråga (borde inte hända)
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
        <p className="text-yellow-800 mb-4">Laddar nästa fråga...</p>
      </div>
    </div>
  );
};

export default ThemeProgress;
